// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"DeleteTasks_AssignChecklist__tYzt9","modalBody":"DeleteTasks_modalBody__ZfAPn","formControl":"DeleteTasks_formControl__NP8dR"};